import React, { useState } from "react";
import { Col, Container, Row, Button, Form, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Notification, { showToast } from "../../../components/common/notification/Notification";

const AddLeasePurpose = () => {
  const navigate = useNavigate();
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState?.user ?? authState;
  const token = loggedInUser?.refreshToken || authState?.refreshToken || loggedInUser?.token || authState?.token;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      showToast("Please enter a name for the lease purpose.", { type: "error" });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/lease-purpose/add`,
        {
          name: formData.name,
          description: formData.description,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 || response.data?.statusType === "SUCCESS") {
        showToast("Lease Purpose added successfully!", { type: "success" });
        setTimeout(() => {
          navigate("/lease-purpose");
        }, 1200);
      } else {
        showToast(response.data?.text || "Failed to add Lease Purpose.", { type: "error" });
      }
    } catch (error) {
      console.error("Error adding lease purpose:", error);
      showToast("Error adding Lease Purpose. Please try again.", { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Lease Purpose", link: "/lease-purpose" },
    { label: "Add Lease Purpose", link: "/lease-purpose/add-leasePurpose", active: true },
  ];

  return (
    <>
      <Notification />
      <div className="content-body2">
        <Container>
          <BreadCrumb items={breadcrumbItems} />
          <Row>
            <Col lg={12} md={12} sm={12}>
              <SingleDetailHeader
                header="Add Lease Purpose"
                description="Create a new lease purpose type."
              />

              <Form onSubmit={handleSubmit} className="bg-white p-4 rounded shadow-sm border mt-3">
                <Form.Group controlId="formName" className="mb-3">
                  <Form.Label className="fw-semibold">Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="e.g. Residential Lease"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formDescription" className="mb-4">
                  <Form.Label className="fw-semibold">Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Enter description..."
                  />
                </Form.Group>

                <div className="d-flex justify-content-end gap-2">
                  <Button variant="secondary" onClick={() => navigate("/lease-purpose")} disabled={loading}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Saving...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default AddLeasePurpose;
